import { createSlice, type PayloadAction } from "@reduxjs/toolkit";
import type { PortalCompanySettings } from "@/actions/ssr/settings/portal/getPortalCompanySettingsSSR";

const FALLBACK: PortalCompanySettings = {
  currency: null,
  timezone: null,
  country: null,
  companyName: null,
};

interface PortalCompanySettingsState {
  data: PortalCompanySettings;
  clientFetched: boolean;
}

const initialState: PortalCompanySettingsState = {
  data: FALLBACK,
  clientFetched: false,
};

const portalCompanySettingsSlice = createSlice({
  name: "portalCompanySettings",
  initialState,
  reducers: {
    setPortalCompanySettingsFromSSR(
      state,
      action: PayloadAction<PortalCompanySettings>,
    ) {
      if (state.clientFetched) return;
      state.data = action.payload;
    },
  },
});

export const { setPortalCompanySettingsFromSSR } =
  portalCompanySettingsSlice.actions;
export default portalCompanySettingsSlice.reducer;
